const all = ['audiometry']
const audiometerInstances = [...all, 'audiometerInstance']
const audiometerInstance = (id: number) => [...audiometerInstances, id]

export const audiometryKeys = {
  all,
  audiometerInstances,
  audiometerInstance,
}
